import {useEffect, useState} from 'react';
import style from "./slide.module.less";

export default function Slide({images}) {

  const [actualImg, setActualImg] = useState(0);

  function handleChangeImg(direcction){
    if (direcction === "right"){
      if (actualImg < images.length-1) setActualImg(actualImg+1);
      else setActualImg(0);
    }else if (direcction === "left"){
      if (actualImg > 0) setActualImg(actualImg-1);
      else setActualImg(images.length-1);
    }
  }

  useEffect(()=>{
    const interval = setInterval(() => {
      handleChangeImg('right');
    }, 5000);
    return () => clearInterval(interval);
  },[actualImg])

  let imgsHTML=null;

  if(Array.isArray(images) && images.length){
    imgsHTML = images.map((img,index)=>{
          const imgid="img-"+index;
          const show = actualImg === index ? style.slideImg + ' ' + style.fadeIn :  style.slideImg + ' ' + style.fadeOut;
          return (
              <div key={index} className={show} id={imgid}>
                  <img key={index} src={img} alt={"Slide " + index}/>
              </div>
          );
    });
  }

  if  (imgsHTML!=null){
    return (
      <div className={style.slide}>
        <div className={style.slideImgsContent}>{imgsHTML}</div>
        <div className={style.imgsButtonsLeft} onClick={() => handleChangeImg("left")}></div>
        <div className={style.imgsButtonsRight} onClick={() => handleChangeImg("right")}></div>
      </div>
    );
  } else return null;

}